import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.9999 9.58366V11.667M12.9999 11.667V13.7503M12.9999 11.667H10.9166M12.9999 11.667H15.0833M12.9041 6.03082C12.0386 4.19078 10.168 2.91699 7.99992 2.91699C5.00838 2.91699 2.58325 5.34212 2.58325 8.33366C2.58325 11.2425 4.8762 13.6159 7.75326 13.7448M18.4166 11.667C18.4166 14.6585 15.9915 17.0837 12.9999 17.0837C10.0084 17.0837 7.58325 14.6585 7.58325 11.667C7.58325 8.67545 10.0084 6.25033 12.9999 6.25033C15.9915 6.25033 18.4166 8.67545 18.4166 11.667Z",
      stroke: "currentColor",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }